import PlurallClient from 'plurall-client'
import { clearToken, getToken } from './token'

class Client {
  constructor(config) {
    this.client = new PlurallClient({
      accept: config ? config.accept : 'vnd.plurall.api.v2+json',
      accessToken: getToken(),
      apiURL: process.env.REACT_APP_PLURALL_API_URL,
      disableAutoCamelize: false,
      onError: this.onError,
    })

    this.getProfile = this.client.getProfile
  }

  get = ({ path, params }) => this.client.get(`${path}`, { params }).then(response => response)

  post = (path, body) => this.client.post(`${path}`, body)

  onError = error => {
    const {
      status,
      data: { message, msg },
    } = error.response

    if (status && status === 401) {
      clearToken()
      window.location.reload()
    }

    window.location.href = `/error?message=${message || msg}&status=${status}`
  }

  getQuestion = questionId => this.get({ path: `/questions/${questionId}` })
}

export default Client
